import styled from "styled-components";

const TitleArea = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: center;
`;

const ButtonArea = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
`;

export { TitleArea, ButtonArea };
